// extracted by mini-css-extract-plugin
export var caseImg = "Unternehmen-module--caseImg--pErk7";
export var filler = "Unternehmen-module--filler--s4sGb";
export var gallery = "Unternehmen-module--gallery--mOHkS";
export var media = "Unternehmen-module--media--yEsUE";
export var title = "Unternehmen-module--title--LhMs8";
export var video = "Unternehmen-module--video--8409v";